import { FC } from 'react'

import { useEmbed } from '../../embed/EmbedProvider'
import { ErrorBoundary } from '../Error/ErrorBoundry'
import { PostCard, PostCardProps } from './PostCard'
import { PostRow } from './PostRow'

export const Post: FC<
  PostCardProps & {
    view?: 'card' | 'row'
  }
> = ({
  view = 'card',
  post,
  context,
  activeTagId = '',
  replyBar = true,
  collapsible = true,
  readonly,
  showContent,
  ...rest
}) => {
  const { values } = useEmbed()
  const _view = values.postView || view
  if (_view === 'row') {
    return (
      <ErrorBoundary>
        <PostRow post={post} context={context} />
      </ErrorBoundary>
    )
  }
  return (
    <ErrorBoundary>
      <PostCard
        post={post}
        context={context}
        activeTagId={activeTagId}
        replyBar={(values.replyBar as boolean) ?? replyBar}
        collapsible={(values.replyBar as boolean) ?? collapsible}
        readonly={(values.readonly as boolean) ?? readonly}
        showContent={(values.showContent as boolean) ?? showContent}
        {...rest}
      />
    </ErrorBoundary>
  )
}
